import React, { createContext, useContext, useState } from 'react';

interface User {
  dob?: string;
  email?: string;
  isUserCBPT?: boolean;
  name?: string;
  nextBillingDate?: string;
  stripeCustomerId?: string;
}

type UserWithChildren = { children: React.ReactNode; user: User };

const SubscribeFormContext = createContext<{
  user: User;
  setUser: (values: User) => void;
}>({
  user: {
    dob: '',
    email: '',
    name: '',
    stripeCustomerId: '',
  },
  setUser: () => undefined,
});

export const SubscribeFormProvider = ({
  children,
  user: { dob, email, isUserCBPT, name, nextBillingDate, stripeCustomerId },
}: UserWithChildren) => {
  const [user, setUser] = useState<User>({
    dob,
    email,
    isUserCBPT,
    name,
    nextBillingDate,
    stripeCustomerId,
  });

  return (
    <SubscribeFormContext.Provider value={{ user, setUser }}>
      {children}
    </SubscribeFormContext.Provider>
  );
};

export const useSubscribeForm = () => {
  const context = useContext(SubscribeFormContext);
  return context;
};
